import script from "./PushOptIn.vue?vue&type=script&setup=true&lang=js"
export * from "./PushOptIn.vue?vue&type=script&setup=true&lang=js"

import "./PushOptIn.vue?vue&type=style&index=0&id=0423a166&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0423a166"]])

export default __exports__